import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46d79422"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-wrapper" }
const _hoisted_2 = { class: "scrollable-content" }
const _hoisted_3 = { class: "info-section" }
const _hoisted_4 = { class: "notification-header" }
const _hoisted_5 = { class: "notification-icon" }
const _hoisted_6 = { class: "notification-details" }
const _hoisted_7 = { class: "notification-title" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "notification-subtitle" }, "Push Notifications", -1))
const _hoisted_9 = {
  key: 0,
  class: "status-section"
}
const _hoisted_10 = { class: "status-card status-card--red" }
const _hoisted_11 = { class: "status-content" }
const _hoisted_12 = { class: "status-title" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "status-subtitle" }, "Permission Required", -1))
const _hoisted_14 = { class: "details-section" }
const _hoisted_15 = { class: "details-card" }
const _hoisted_16 = { class: "detail-item" }
const _hoisted_17 = { class: "detail-item" }
const _hoisted_18 = { class: "detail-item" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Features:", -1))
const _hoisted_20 = { class: "feature-list" }
const _hoisted_21 = { class: "detail-item" }
const _hoisted_22 = { class: "toggle-section" }
const _hoisted_23 = { class: "toggle-card" }
const _hoisted_24 = { class: "toggle-content" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "toggle-label" }, "Enable Notifications", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createBlock(_component_ion_content, { class: "text-selectable modal-content" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_font_awesome_icon, { icon: ['fas', 'bell'] })
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.t('notifications-modal.title')), 1),
                _hoisted_8
              ])
            ])
          ]),
          (_ctx.hasPermissions === false)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.t("error-messages.no-notifications-permissions")), 1),
                    _hoisted_13
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("h4", null, _toDisplayString(_ctx.t('notifications-modal.content[0]')), 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("p", null, _toDisplayString(_ctx.t('notifications-modal.content[1]')), 1)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("ul", _hoisted_20, [
                  _createElementVNode("li", null, _toDisplayString(_ctx.t('notifications-modal.list[0]')), 1),
                  _createElementVNode("li", null, _toDisplayString(_ctx.t('notifications-modal.list[1]')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("p", null, _toDisplayString(_ctx.t('notifications-modal.content[2]')), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createVNode(_component_ion_toggle, {
                  disabled: _ctx.hasPermissions === false,
                  onIonChange: _ctx.enableNotificationsChange,
                  checked: _ctx.notificationsInfo?.enabled
                }, null, 8, ["disabled", "onIonChange", "checked"])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}